import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import {
  EBnibTransactionSortField,
  IBnibTransaction,
  PBnibTransactionFilter,
} from "src/core/bnibTransaction/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface IBnibTransactionState {
  bnibTransactions: IBnibTransaction[];
  loading: boolean;
  error: any;
  meta: IMeta;
}

const initialState: IBnibTransactionState = {
  bnibTransactions: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "bnib-transaction/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "bnib-transaction/FETCH_SUCCEEDED";
const FETCH_FAILED = "bnib-transaction/FETCH_FAILED";
const POLLING_START_REQUESTED = "bnib-transaction/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "bnib-transaction/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IBnibTransaction[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<any>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    filter: PBnibTransactionFilter;
    pagination: IPagination;
    sorts: ISort<EBnibTransactionSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IBnibTransactionState, TActions> = (
  state = initialState,
  action
) => {
  return produce<IBnibTransactionState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.bnibTransactions = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
